// extracted by mini-css-extract-plugin
export default {"wrapper":"JhiJi85Jz9T7IJIDSTTw"};